var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guest-login flex flex-col h-full h-screen items-center justify-center"},[(_vm.isBusy)?_c('mj-spinner',{attrs:{"size":200}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }